/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { FSxRestoreDestination } from '../models/FSxRestoreDestination';

export class RestoreFSxRequest {
  /**
  * Eon-assigned ID of the restore account where the FSx file system will be restored.
  */
  'restoreAccountId': string;
  'destination': FSxRestoreDestination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreAccountId",
      "baseName": "restoreAccountId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "destination",
      "baseName": "destination",
      "type": "FSxRestoreDestination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreFSxRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

